import { render, staticRenderFns } from "./adf-system-admin-info.vue?vue&type=template&id=20e693a4&scoped=true&"
import script from "./adf-system-admin-info.vue?vue&type=script&lang=js&"
export * from "./adf-system-admin-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e693a4",
  null
  
)

export default component.exports